import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@campfire-nx/material';

import { environment } from '@open-portal-env';

// campfire
import { PartnerBrandService, PartnerService, LoggerService } from '@campfire-nx/api';

// services
import { PolicyDetailsService } from '@open-portal-app/core/services/policy-details.service';
import { TpaService } from '@open-portal-app/core/services/tpa.service';

@Component({
  selector: 'claim-triage',
  templateUrl: './claim-triage.component.html',
  styleUrl: './claim-triage.component.scss'
})
export class ClaimTriageComponent {
  fetchingHandoverData = false;
  policyDetails!: any;
  emergencyLinkText!: string;
  emergencyLinkNumber!: string;
  form!: FormGroup;
  coverContent = {
    default: {
      text: 'Something else happened during my trip (Lost baggage, holiday cancellation, medical expenses, or something else)',
      icon: 'management-travelinsurance'
    },
    extra_gadget: {
      text: 'My phone, laptop, or other gadget was lost, stolen, or damaged during my trip',
      icon: 'marketing-optionals'
    }
  };
  triageQuestion = {
    key: 'claim-triage',
    type: 'choice',
    settings: { choices: [] }
  };
  apiEndpoint?: string;
  handoverDetails = {
    tpaUrl: '',
    tpaName: '',
    tpaIcon: '',
    tpaSection: {
      title: '',
      content: ''
    }
  };

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private policyDetailsService: PolicyDetailsService,
      private partnerBrandService: PartnerBrandService,
      private partnerService: PartnerService,
      private tpaService: TpaService,
      public location: Location,
      private loggerService: LoggerService,
      public dialog: MatDialog
    ) {}

  ngOnInit(): void {
    const companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');
    this.emergencyLinkText = companyInfo.SUPPORT_PHONE_INTL;
    this.emergencyLinkNumber = companyInfo.SUPPORT_PHONE_INTL_COMPACT;
    this.apiEndpoint = environment.apiEndpoint;

    if (this.route.snapshot.data.policy) {
      this.policyDetailsService.formatPolicy()
        .then((response: any) => {
          this.policyDetails = response;
          this.triageQuestion.settings.choices = this.getTriageChoices();

          this.form = new FormGroup({});
          this.form.addControl(
            'claim-triage',
            new FormControl(this.triageQuestion)
          );

          // Subscribe to specific form control changes
          this.form.get('claim-triage')?.valueChanges.subscribe(value => {
            this.goToClaimTpa(value);
          });

        })
        .catch((err: any) => {
          this.loggerService.error('ClaimTriageComponent', 'ngOnInit', { error: err });
        });
    }
  }

  goBack(): void {
    this.location.back();
  }

  executeCallToAction(): void {
    if (this.handoverDetails.tpaUrl !== '') {
      window.open(this.handoverDetails.tpaUrl, '_blank');
      this.router.navigate([`/policy/${this.policyDetails.productClass}/${this.policyDetails.slug}`]);
    }
  }

  resetHandoverDetails() {
    this.handoverDetails = {
      tpaUrl: '',
      tpaName: '',
      tpaIcon: '',
      tpaSection: {
        title: '',
        content: ''
      }
    }
    this.fetchingHandoverData = false;
  }

  goToClaimTpa(selectedValue: any): void {
    this.resetHandoverDetails();

    // If not answer is selected do nothing
    if (this.form.pristine || typeof(selectedValue) === 'object') {
      return;
    }

    const selectedTpa: any = this.triageQuestion.settings.choices.find(
      (choice: any) => choice.value === selectedValue
    );

    this.fetchingHandoverData = true;
    this.partnerService.brand(selectedTpa.tpaPartnerSlug).then((response: any) => {
      this.handoverDetails.tpaName = response?.name;
      this.handoverDetails.tpaIcon = response?.brand?.logoLarge;
      this.handoverDetails.tpaSection.title = `We’ve partnered with ${this.handoverDetails.tpaName} to handle your ${ selectedValue === 'extra_gadget' ? 'gadget' : 'travel' } claim quickly and easily`;
      this.handoverDetails.tpaSection.content = `Click Continue to be securely transferred to ${this.handoverDetails.tpaName}’s website to complete your claim.`;

      return this.tpaService.handoverToTpa({
        policy_uuid: this.policyDetails.slug,
        for_cover: selectedValue
      })
    }).then((response: any) => {
      this.handoverDetails.tpaUrl = response?.url || '';
      this.fetchingHandoverData = false;
    })
    .catch((err: any) => {
      this.loggerService.error('ClaimTriageComponent', 'goToClaimTpa', { error: err });
      this.fetchingHandoverData = false;
    });
  }

  getTriageChoices() {
    return this.policyDetails.fnolTPAs.map((tpa: { for_cover: string; tpa_partner: string; }) => ({
      text: this.coverContent[tpa.for_cover as keyof typeof this.coverContent].text,
      icon: this.coverContent[tpa.for_cover as keyof typeof this.coverContent].icon,
      value: tpa.for_cover,
      tpaPartnerSlug: tpa.tpa_partner
    }));
  }
}
